/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModulePrimaryOld_homepage = {
    readonly promoPrimaryModule: {
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly imageCopy: string | null;
            readonly cta: string | null;
            readonly imageUrl?: string | null;
            readonly mobileImageUrl?: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespPromoModulePrimaryOld_homepage";
};
export type HpRespPromoModulePrimaryOld_homepage$data = HpRespPromoModulePrimaryOld_homepage;
export type HpRespPromoModulePrimaryOld_homepage$key = {
    readonly " $data"?: HpRespPromoModulePrimaryOld_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePrimaryOld_homepage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModulePrimaryOld_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "promoPrimaryModule",
      "name": "module",
      "storageKey": "module(type:\"promoPrimary\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "promoPrimary"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PromoModule",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "PromoItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageCopy",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cta",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": false,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "mobileImageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'd1cec97074df40a3e32b703424c44873';
export default node;
